<template>
  <div class="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg" dir="rtl">
    <!-- En-tête avec Logo -->
    <div class="text-center mb-8 border-b pb-4">
      <div class="flex justify-center mb-4">
        <img 
          src="images/logo.png" 
          alt="Profert" 
          class="h-20 w-auto object-contain"
          @error="handleImageError"
        >
      </div>
      <h2 class="text-xl font-semibold text-blue-900 mt-2">استمارة تقديم شكوى</h2>
      <p class="w-4/5 mx-auto text-center text-sm text-gray-600 mt-2">
        يرجى ملء الإستمارة أدناه حتى نتمكن من معالجة طلبكم في أقرب وقت ممكن.
      </p>
    </div>

    <form @submit.prevent="submitForm" class="space-y-6">
      <!-- Section معلومات العميل -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">معلومات الزبون</h3>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- الاسم الكامل -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              الاسم الكامل <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              v-model="form.nom_prenom"
              required
              placeholder="أدخل اسمك الكامل"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
          </div>

          <!-- البريد الإلكتروني -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              البريد الإلكتروني
            </label>
            <input
              type="email"
              v-model="form.email"
              placeholder="بريدك@الإلكتروني.com"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
          </div>

          <!-- الصفة -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              الصفة <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.statut"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
              <option value="">اختر الصفة</option>
              <option value="فلاح">فلاح</option>
              <option value="بائع البذور و المعدات الفلاحية"> بائع البذور و المعدات الفلاحية</option>
              <option value="أخرى">أخرى</option>
            </select>
          </div>

          <!-- الولاية -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              الولاية <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.wilaya"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
              <option value="">اختر ولايتك</option>
              <option value="أدرار">01 - أدرار</option>
              <option value="الشلف">02 - الشلف</option>
              <option value="الأغواط">03 - الأغواط</option>
              <option value="أم البواقي">04 - أم البواقي</option>
              <option value="باتنة">05 - باتنة</option>
              <option value="بجاية">06 - بجاية</option>
              <option value="بسكرة">07 - بسكرة</option>
              <option value="بشار">08 - بشار</option>
              <option value="البليدة">09 - البليدة</option>
              <option value="البويرة">10 - البويرة</option>
              <option value="تمنراست">11 - تمنراست</option>
              <option value="تبسة">12 - تبسة</option>
              <option value="تلمسان">13 - تلمسان</option>
              <option value="تيارت">14 - تيارت</option>
              <option value="تيزي وزو">15 - تيزي وزو</option>
              <option value="الجزائر">16 - الجزائر</option>
              <option value="الجلفة">17 - الجلفة</option>
              <option value="جيجل">18 - جيجل</option>
              <option value="سطيف">19 - سطيف</option>
              <option value="سعيدة">20 - سعيدة</option>
              <option value="سكيكدة">21 - سكيكدة</option>
              <option value="سيدي بلعباس">22 - سيدي بلعباس</option>
              <option value="عنابة">23 - عنابة</option>
              <option value="قالمة">24 - قالمة</option>
              <option value="قسنطينة">25 - قسنطينة</option>
              <option value="المدية">26 - المدية</option>
              <option value="مستغانم">27 - مستغانم</option>
              <option value="المسيلة">28 - المسيلة</option>
              <option value="معسكر">29 - معسكر</option>
              <option value="ورقلة">30 - ورقلة</option>
              <option value="وهران">31 - وهران</option>
              <option value="البيض">32 - البيض</option>
              <option value="إليزي">33 - إليزي</option>
              <option value="برج بوعريريج">34 - برج بوعريريج</option>
              <option value="بومرداس">35 - بومرداس</option>
              <option value="الطارف">36 - الطارف</option>
              <option value="تندوف">37 - تندوف</option>
              <option value="تيسمسيلت">38 - تيسمسيلت</option>
              <option value="الوادي">39 - الوادي</option>
              <option value="خنشلة">40 - خنشلة</option>
              <option value="سوق أهراس">41 - سوق أهراس</option>
              <option value="تيبازة">42 - تيبازة</option>
              <option value="ميلة">43 - ميلة</option>
              <option value="عين الدفلى">44 - عين الدفلى</option>
              <option value="النعامة">45 - النعامة</option>
              <option value="عين تموشنت">46 - عين تموشنت</option>
              <option value="غرداية">47 - غرداية</option>
              <option value="غليزان">48 - غليزان</option>
              <option value="المغير">49 - المغير</option>
              <option value="المنيعة">50 - المنيعة</option>
              <option value="أولاد جلال">51 - أولاد جلال</option>
              <option value="برج باجي مختار">52 - برج باجي مختار</option>
              <option value="بني عباس">53 - بني عباس</option>
              <option value="تيميمون">54 - تيميمون</option>
              <option value="تقرت">55 - تقرت</option>
              <option value="جانت">56 - جانت</option>
              <option value="عين صالح">57 - عين صالح</option>
              <option value="عين قزام">58 - عين قزام</option>
            </select>
          </div>

          <!-- الهاتف -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              الهاتف <span class="text-red-500">*</span>
            </label>
            <div class="flex">
              <div class="relative">
                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <span class="text-gray-500">+213</span>
                </div>
                <input
                  type="tel"
                  v-model="form.telephone"
                  @input="formatPhoneNumber"
                  required
                  maxlength="9"
                  placeholder="551234567"
                  class="w-full pr-16 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
                >
              </div>
            </div>
            <p class="text-xs text-gray-500 mt-1 text-right" v-if="form.telephone">
              {{ 9 - form.telephone.replace(/\D/g, '').length }} أرقام متبقية
            </p>
          </div>

          <!-- رمز العميل -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              رمز الزبون
            </label>
            <input
              type="text"
              v-model="form.codeclient"
              placeholder="رمز الزبون"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
          </div>

          <!-- قناة الشراء -->
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              قناة الشراء <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.canal_achat"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
              <option value="">اختر قناة الشراء</option>
              <option value="profert">بروفارت</option>
              <option value="grainetier"> بائع البذور و المعدات الفلاحية</option>
              <option value="ccls">CCLS</option>
            </select>
          </div>

          <!-- تم تقديم الشكوى من طرف ممثل بروفارت -->
          <div class="md:col-span-2">
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
                تم تقديم الشكوى من طرف ممثل بروفارت <span class="text-red-500">*</span>
              </label>
              <div class="flex items-center space-x-6 space-x-reverse">
                <label class="flex items-center space-x-2 space-x-reverse">
                  <input
                    type="radio"
                    v-model="form.rempli_par_representant"
                    value="oui"
                    class="rounded-full border-gray-300 text-blue-600 focus:ring-blue-500"
                  >
                  <span class="text-sm text-gray-700 mr-2">نعم</span>
                </label>
                <label class="flex items-center space-x-2 space-x-reverse">
                  <input
                    type="radio"
                    v-model="form.rempli_par_representant"
                    value="non"
                    class="rounded-full border-gray-300 text-blue-600 focus:ring-blue-500"
                  >
                  <span class="text-sm text-gray-700 mr-2">لا</span>
                </label>
              </div>
            </div>
            
            <div v-if="form.rempli_par_representant === 'oui'">
              <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
                اسم ممثل بروفارت <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                v-model="form.representant_profert"
                :required="form.rempli_par_representant === 'oui'"
                placeholder="اسم ممثل بروفارت"
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Section معلومات المنتج -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">معلومات المنتوج</h3>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- مجموعة المنتج -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              مجموعة المنتوج <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.gamme_produit"
              @change="onGammeChange"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
              :disabled="loadingGammes"
            >
              <option value="">اختر مجموعة</option>
              <option 
                v-for="gamme in gammes" 
                :key="gamme.id" 
                :value="gamme.id"
              >
                {{ gamme.name_ar }}
              </option>
            </select>
            <div v-if="loadingGammes" class="text-sm text-gray-500 mt-1 text-right">
              جاري تحميل المجموعات...
            </div>
          </div>

          <!-- المنتج مع بحث مبسط -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              المنتوج <span class="text-red-500">*</span>
            </label>
            
            <div class="relative">
              <!-- حقل البحث مع القائمة المنسدلة -->
              <div class="relative">
                <input 
                  type="text" 
                  v-model="produitSearch"
                  @focus="onProduitInputFocus"
                  @blur="onProduitInputBlur"
                  @input="filterProduits"
                  @keydown.down="navigateDropdown('down')"
                  @keydown.up="navigateDropdown('up')"
                  @keydown.enter="selectHighlightedProduit"
                  :placeholder="form.gamme_produit ? 'ابحث أو اختر المنتوج...' : 'اختر مجموعة أولاً'"
                  :class="[
                    'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-right',
                    !form.gamme_produit || loadingProduits ? 'bg-gray-100 border-gray-300 text-gray-500 cursor-not-allowed' : 
                    showProduitDropdown && filteredProduits.length > 0 ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-300 focus:ring-blue-500'
                  ]"
                  :disabled="!form.gamme_produit || loadingProduits"
                  ref="produitInput"
                >

                <!-- أيقونة البحث -->
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
                  <i v-if="loadingProduits" class="fas fa-spinner fa-spin text-gray-400"></i>
                  <i v-else-if="!loadingProduits && form.gamme_produit" class="fas fa-search text-gray-400"></i>
                </div>

                <!-- القائمة المنسدلة للنتائج -->
                <div 
                  v-if="showProduitDropdown && filteredProduits.length > 0" 
                  class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto text-right"
                  ref="dropdown"
                >
                  <div 
                    v-for="(produit, index) in filteredProduits" 
                    :key="produit.id"
                    @mousedown="selectProduit(produit)"
                    :class="[
                      'px-3 py-2 cursor-pointer transition-colors',
                      index === highlightedIndex ? 'bg-blue-100 text-blue-700' : 'hover:bg-blue-50',
                      form.produit_id == produit.id ? 'bg-blue-50 text-blue-700 font-medium' : ''
                    ]"
                  >
                    {{ produit.name_ar }}
                  </div>
                </div>
              </div>

              <!-- حقل مخفي للتحقق -->
              <input type="hidden" v-model="form.produit_id" required>

              <!-- رسالة التحميل -->
              <div v-if="loadingProduits" class="text-sm text-gray-500 mt-1 text-right">
                جاري تحميل المنتوجات...
              </div>

              <!-- رسالة إذا لم توجد نتائج -->
              <div 
                v-if="produitSearch && filteredProduits.length === 0 && !loadingProduits && form.gamme_produit" 
                class="text-sm text-gray-500 mt-1 text-right"
              >
                لم يتم العثور على المنتوج لـ "{{ produitSearch }}"
              </div>

              <!-- رسالة إذا لم يتم اختيار مجموعة -->
              <div 
                v-if="!form.gamme_produit" 
                class="text-sm text-yellow-600 mt-1 text-right"
              >
                الرجاء اختيار مجموعة أولاً
              </div>
            </div>
          </div>

          <!-- سبب الشكوى -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              سبب الشكوى <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.motif"
              required
              @change="onMotifChange"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
              :disabled="loadingMotifs"
            >
              <option value="">اختر السبب</option>
              <option 
                v-for="motif in motifs" 
                :key="motif.id" 
                :value="motif.id"
              >
                {{ motif.name_ar }}
              </option>
            </select>
            <div v-if="loadingMotifs" class="text-sm text-gray-500 mt-1 text-right">
              جاري تحميل الأسباب...
            </div>
          </div>

          <!-- رقم الدفعة -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              رقم الحصة<span v-if="isNumeroLotRequired" class="text-red-500">*</span>
            </label>
            <input
              type="text"
              v-model="form.numero_lot"
              :required="isNumeroLotRequired"
              placeholder="رقم الحصة"
              :class="[
                'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-right',
                isNumeroLotRequired && !form.numero_lot ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
              ]"
            >
            <p v-if="isNumeroLotRequired && !form.numero_lot" class="text-sm text-red-600 mt-1 text-right">
              <i class="fas fa-exclamation-circle ml-1"></i>
              هذا الحقل إلزامي لهذا السبب
            </p>
          </div>

          <!-- تاريخ التسليم -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              تاريخ التسليم <span class="text-red-500">*</span>
            </label>
            <input
              type="date"
              v-model="form.date_livraison"
              @change="validateDateLivraison"
              :max="maxDate"
              :class="[
                'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 text-right',
                dateError ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'
              ]"
              required
            >
            <!-- رسالة الخطأ -->
            <p v-if="dateError" class="text-sm text-red-600 mt-1 text-right">
              <i class="fas fa-exclamation-circle ml-1"></i>
              {{ dateError }}
            </p>
            <!-- تلميح للمستخدم -->
            <p v-else class="text-xs text-gray-500 mt-1 text-right">
              <i class="fas fa-info-circle ml-1"></i>
              لا يمكن أن يكون التاريخ لاحقاً لليوم
            </p>
          </div>

          <!-- الكمية غير المطابقة -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
              الكمية غير المطابقة
            </label>
            <input
              type="text"
              v-model="form.quantite_non_conforme"
              placeholder="مثال: 10 كغ، 5 أكياس، إلخ"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
            >
          </div>
        </div>

        <!-- رفع الملفات (قسم منفصل) -->
        <div v-if="form.motif" class="mt-6 pt-6 border-t">
          <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
            الملفات المرفقة (صور، PDF، Word)
          </label>
          <div
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="handleDrop"
            :class="[
              'border-2 border-dashed rounded-lg p-6 text-center transition-colors',
              isDragging ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'
            ]"
          >
            <i class="fas fa-cloud-upload-alt text-4xl text-gray-400 mb-3"></i>
            <p class="text-sm text-gray-600 mb-2">
              اسحب وأفلت ملفاتك هنا، أو
            </p>
            <label class="cursor-pointer">
              <span class="text-blue-600 hover:text-blue-700 font-medium">تصفح الملفات</span>
              <input
                type="file"
                @change="handleFileSelect"
                multiple
                accept="image/*,.pdf,.doc,.docx"
                class="hidden"
              >
            </label>
            <p class="text-xs text-gray-500 mt-2">
              الصيغ المقبولة: الصور (JPG, PNG)، PDF، Word (DOC, DOCX)
            </p>
          </div>

          <!-- قائمة الملفات المختارة -->
          <div v-if="selectedFiles.length > 0" class="mt-4 space-y-2">
            <div
              v-for="(file, index) in selectedFiles"
              :key="index"
              class="flex items-center justify-between p-3 bg-gray-50 rounded-md border border-gray-200"
            >
              <div class="flex items-center space-x-3" dir="ltr">
                <i :class="getFileIcon(file.type)" class="text-gray-500"></i>
                <div>
                  <p class="text-sm font-medium text-gray-700">{{ file.name }}</p>
                  <p class="text-xs text-gray-500">{{ formatFileSize(file.size) }}</p>
                </div>
              </div>
              <button
                type="button"
                @click="removeFile(index)"
                class="text-red-500 hover:text-red-700"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section الوصف -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <h3 class="text-lg font-semibold text-blue-900 mb-4 border-b pb-2">الوصف</h3>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2 text-right">
            وصف مفصل للشكوى
          </label>
          <textarea
            v-model="form.description"
            rows="6"
            placeholder="صف المشكلة التي واجهتها بالتفصيل..."
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-vertical text-right"
          ></textarea>
        </div>
      </div>

      <!-- Section CAPTCHA والأزرار -->
      <div class="bg-gray-50 p-6 rounded-lg">
        <div class="flex flex-wrap items-center justify-between gap-4">
          <!-- رمز CAPTCHA -->
          <div class="flex items-center gap-4 bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
            <div class="bg-gray-100 px-3 py-2 rounded-md border-2 border-dashed border-blue-300">
              <span class="text-lg font-mono font-bold text-blue-600 tracking-wider select-none">
                {{ captcha.num1 }} + {{ captcha.num2 }} = ؟
              </span>
            </div>

            <!-- إدخال الإجابة -->
            <div class="flex flex-col items-center">
              <input
                type="number"
                v-model="captcha.userInput"
                @input="validateCaptcha"
                class="w-20 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-center font-mono"
                placeholder="الناتج"
                min="0"
                max="20"
              >
              <button
                type="button"
                @click="generateCaptcha"
                class="text-blue-600 hover:text-blue-700 text-xs mt-1 flex items-center justify-center"
              >
                <i class="fas fa-redo ml-1"></i>
                عملية جديدة
              </button>
            </div>

            <!-- مؤشر التحقق -->
            <div class="mr-4">
              <div v-if="captcha.isValid" class="text-green-600 text-sm flex items-center">
                <i class="fas fa-check-circle ml-1"></i>
                إجابة صحيحة!
              </div>
              <div v-else-if="captcha.userInput" class="text-red-600 text-sm flex items-center">
                <i class="fas fa-times-circle ml-1"></i>
                إجابة خاطئة
              </div>
            </div>
          </div>

          <!-- أزرار الإجراء -->
          <div class="flex items-center gap-3">
            <button
              type="button"
              @click="resetForm"
              class="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition flex items-center justify-center"
            >
              <i class="fas fa-redo ml-2"></i>
              إعادة تعيين
            </button>
            <button
              type="submit"
              :disabled="isSubmitting || !captcha.isValid"
              class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center"
            >
              <i class="fas fa-paper-plane ml-2"></i>
              {{ isSubmitting ? 'جاري الإرسال...' : 'إرسال' }}
            </button>
          </div>
        </div>

        <p class="text-xs text-gray-500 text-center mt-2">
          هذه العملية تحمي من الإرسال الآلي.
        </p>
      </div>
    </form>

    <!-- نافذة التأكيد -->
    <div v-if="showSuccess" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg max-w-md mx-4 shadow-2xl" dir="rtl">
        <div class="text-center">
          <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i class="fas fa-check text-green-600 text-2xl"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-800 mb-2">تم إرسال الشكوى!</h3>
          <p class="text-gray-600 mb-4">تم تقديم شكواك بنجاح. سنقوم بمعالجتها في أقرب وقت ممكن.</p>
          <button
            @click="closeSuccessModal"
            class="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReclamationFormAr',
  data() {
    return {
      form: {
        nom_prenom: '',
        email: '',
        statut: '',
        wilaya: '',
        telephone: '',
        codeclient: '',
        canal_achat: '',
        rempli_par_representant: '',
        representant_profert: '',
        gamme_produit: '',
        produit_id: '',
        numero_lot: '',
        date_livraison: '',
        quantite_non_conforme: '',
        motif: '',
        description: ''
      },
      gammes: [],
      produits: [],
      motifs: [],
      selectedFiles: [],
      isDragging: false,
      showSuccess: false,
      isSubmitting: false,
      loadingGammes: false,
      loadingProduits: false,
      loadingMotifs: false,
      captcha: {
        num1: 0,
        num2: 0,
        result: 0,
        userInput: '',
        isValid: false
      },
      produitSearch: '',
      allProduits: [],
      filteredProduits: [],
      showProduitDropdown: false,
      highlightedIndex: -1,
      dateError: '',
      maxDate: '',
      qualityMotifIds: []
    }
  },
  
  computed: {
    isNumeroLotRequired() {
      if (!this.form.motif) return false;
      
      const selectedMotif = this.motifs.find(m => m.id == this.form.motif);
      if (!selectedMotif) return false;
      
      const motifName = selectedMotif.name_ar.toLowerCase();
      return motifName.includes('جودة') || motifName.includes('نوعية');
    }
  },
  
  watch: {
    'form.produit_id'(newVal) {
      if (newVal && this.allProduits.length > 0) {
        const produit = this.allProduits.find(p => p.id == newVal);
        if (produit) {
          this.produitSearch = produit.name_ar;
        }
      } else if (!newVal) {
        this.produitSearch = '';
      }
    }
  },
  
  async mounted() {
    await this.fetchGammes();
    await this.fetchMotifs();
    
    this.generateCaptcha();
    this.setMaxDate();
  },
  
  methods: {
    generateCaptcha() {
      this.captcha.num1 = Math.floor(Math.random() * 10) + 1;
      this.captcha.num2 = Math.floor(Math.random() * 10) + 1;
      this.captcha.result = this.captcha.num1 + this.captcha.num2;
      this.captcha.userInput = '';
      this.captcha.isValid = false;
    },
    
    validateCaptcha() {
      if (!this.captcha.userInput) {
        this.captcha.isValid = false;
        return;
      }
      
      const userAnswer = parseInt(this.captcha.userInput);
      this.captcha.isValid = userAnswer === this.captcha.result;
    },

    async fetchGammes() {
      this.loadingGammes = true;
      try {
        const response = await fetch('/api/gammes', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.gammes = data.data || [];
        } else {
          console.error('خطأ في تحميل المجموعات');
          this.gammes = [];
        }
      } catch (error) {
        console.error('خطأ:', error);
        this.gammes = [];
      } finally {
        this.loadingGammes = false;
      }
    },

    async fetchProduits(gammeId) {
      if (!gammeId) {
        this.allProduits = [];
        this.filteredProduits = [];
        this.produitSearch = '';
        this.form.produit_id = '';
        return;
      }

      this.loadingProduits = true;
      try {
        const response = await fetch(`/api/gammes/${gammeId}/produits`, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.allProduits = data.data || [];
          this.filteredProduits = [...this.allProduits];
          this.produitSearch = '';
          this.produits = data.data || [];
        } else {
          console.error('خطأ في تحميل المنتجات');
          this.allProduits = [];
          this.filteredProduits = [];
          this.produits = [];
        }
      } catch (error) {
        console.error('خطأ:', error);
        this.allProduits = [];
        this.filteredProduits = [];
        this.produits = [];
      } finally {
        this.loadingProduits = false;
      }
    },

    async fetchMotifs() {
      this.loadingMotifs = true;
      try {
        const response = await fetch('/api/motifs', {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // NE PAS TRIER - garder l'ordre de la base de données
          this.motifs = data.data || [];
          
          this.qualityMotifIds = this.motifs
            .filter(motif => 
              motif.name_ar.toLowerCase().includes('جودة') || 
              motif.name_ar.toLowerCase().includes('نوعية')
            )
            .map(motif => motif.id);
        } else {
          console.error('خطأ في تحميل الأسباب');
          this.motifs = [];
          this.qualityMotifIds = [];
        }
      } catch (error) {
        console.error('خطأ:', error);
        this.motifs = [];
        this.qualityMotifIds = [];
      } finally {
        this.loadingMotifs = false;
      }
    },

    onGammeChange() {
      this.form.produit_id = '';
      this.produitSearch = '';
      this.showProduitDropdown = false;
      
      if (this.form.gamme_produit) {
        this.fetchProduits(this.form.gamme_produit);
      } else {
        this.allProduits = [];
        this.filteredProduits = [];
      }
    },

    onMotifChange() {
      if (!this.form.motif) {
        this.selectedFiles = [];
      }
    },

    selectProduit(produit) {
      this.form.produit_id = produit.id;
      this.produitSearch = produit.name_ar;
      this.showProduitDropdown = false;
    },

    clearProduitSelection() {
      this.form.produit_id = '';
      this.produitSearch = '';
      this.showProduitDropdown = true;
      this.$nextTick(() => {
        const input = this.$el.querySelector('input[type="text"][v-model="produitSearch"]');
        if (input) input.focus();
      });
    },

    onProduitInputBlur() {
      setTimeout(() => {
        this.showProduitDropdown = false;
      }, 200);
    },

    onProduitInputFocus() {
      if (this.form.gamme_produit && this.allProduits.length > 0) {
        this.showProduitDropdown = true;
        this.filterProduits();
      }
    },

    filterProduits() {
      if (!this.form.gamme_produit) {
        this.filteredProduits = [];
        return;
      }

      const searchTerm = this.produitSearch.toLowerCase().trim();
      
      if (!searchTerm) {
        this.filteredProduits = [...this.allProduits];
      } else {
        this.filteredProduits = this.allProduits.filter(produit =>
          produit.name_ar.toLowerCase().includes(searchTerm)
        );
      }
      
      this.showProduitDropdown = true;
    },

    navigateDropdown(direction) {
      if (!this.showProduitDropdown || this.filteredProduits.length === 0) return;
      
      event.preventDefault();
      
      if (direction === 'down') {
        this.highlightedIndex = 
          this.highlightedIndex < this.filteredProduits.length - 1 
            ? this.highlightedIndex + 1 
            : 0;
      } else if (direction === 'up') {
        this.highlightedIndex = 
          this.highlightedIndex > 0 
            ? this.highlightedIndex - 1 
            : this.filteredProduits.length - 1;
      }
      
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdown;
        const items = dropdown?.querySelectorAll('div');
        if (items && items[this.highlightedIndex]) {
          items[this.highlightedIndex].scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        }
      });
    },

    selectHighlightedProduit() {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredProduits.length) {
        this.selectProduit(this.filteredProduits[this.highlightedIndex]);
        this.highlightedIndex = -1;
      }
    },

    setMaxDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      this.maxDate = `${year}-${month}-${day}`;
    },
    
    validateDateLivraison() {
      if (!this.form.date_livraison) {
        this.dateError = '';
        return true;
      }
      
      const selectedDate = new Date(this.form.date_livraison);
      const today = new Date();
      
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      if (selectedDate > today) {
        this.dateError = 'لا يمكن أن يكون تاريخ التسليم لاحقاً لليوم';
        return false;
      }
      
      const minDate = new Date('2000-01-01');
      if (selectedDate < minDate) {
        this.dateError = 'الرجاء إدخال تاريخ صحيح';
        return false;
      }
      
      this.dateError = '';
      return true;
    },

    handleImageError(event) {
      event.target.style.display = 'none';
      const title = document.createElement('h1');
      title.className = 'text-2xl font-bold text-gray-800';
      title.textContent = 'بروفارت';
      event.target.parentElement.appendChild(title);
    },

    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      this.addFiles(files);
    },

    handleDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      this.addFiles(files);
    },

    addFiles(files) {
      const validFiles = files.filter(file => {
        const validTypes = [
          'image/jpeg', 'image/jpg', 'image/png', 'image/gif',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];
        return validTypes.includes(file.type) && file.size <= 10 * 1024 * 1024;
      });

      this.selectedFiles = [...this.selectedFiles, ...validFiles];
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    getFileIcon(fileType) {
      if (fileType.startsWith('image/')) return 'fas fa-file-image text-blue-500';
      if (fileType === 'application/pdf') return 'fas fa-file-pdf text-red-500';
      if (fileType.includes('word')) return 'fas fa-file-word text-blue-600';
      return 'fas fa-file text-gray-500';
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 بايت';
      const k = 1024;
      const sizes = ['بايت', 'كيلوبايت', 'ميجابايت'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    async submitForm() {
      if (!this.captcha.isValid) {
        alert('يرجى حل عملية التحقق بشكل صحيح');
        this.generateCaptcha();
        return;
      }

      if (this.form.date_livraison && !this.validateDateLivraison()) {
        alert('لا يمكن أن يكون تاريخ التسليم لاحقاً لليوم');
        return;
      }
      
      if (this.isNumeroLotRequired && !this.form.numero_lot) {
        alert('رقم الدفعة إلزامي لهذا السبب من الشكوى');
        return;
      }

      if (!this.validateForm()) {
        this.generateCaptcha();
        return;
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        
        const selectedGamme = this.gammes.find(g => g.id == this.form.gamme_produit);
        const selectedMotif = this.motifs.find(m => m.id == this.form.motif);
        const selectedProduit = this.allProduits.find(p => p.id == this.form.produit_id);
        
        formData.append('nom_prenom', this.form.nom_prenom);
        formData.append('email', this.form.email);
        formData.append('statut', this.form.statut);
        formData.append('wilaya', this.form.wilaya);
        formData.append('telephone', '+213' + this.form.telephone);
        formData.append('codeclient', this.form.codeclient);
        formData.append('canal_achat', this.form.canal_achat);
        formData.append('rempli_par_representant', this.form.rempli_par_representant);
        formData.append('representant_profert', this.form.representant_profert);

        formData.append('gamme_produit', selectedGamme ? selectedGamme.name_ar : '');
        formData.append('motif', selectedMotif ? selectedMotif.name_ar : '');
        formData.append('produit_name', selectedProduit ? selectedProduit.name_ar : '');
        
        formData.append('numero_lot', this.form.numero_lot);
        formData.append('produit_id', this.form.produit_id);
        formData.append('date_livraison', this.form.date_livraison);
        formData.append('quantite_non_conforme', this.form.quantite_non_conforme);
        formData.append('description', this.form.description);

        formData.append('captcha_result', this.captcha.result);
        formData.append('captcha_user_input', this.captcha.userInput);

        this.selectedFiles.forEach((file, index) => {
          formData.append(`fichiers[${index}]`, file);
        });

        const response = await fetch('/reclamation-ar', {
          method: 'POST',
          headers: {
            'X-CSRF-TOKEN': this.getCsrfToken(),
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        const result = await response.json();

        if (response.ok && result.success) {
          this.showSuccess = true;
          this.generateCaptcha();
        } else {
          throw new Error(result.message || 'خطأ في الإرسال');
        }
        
      } catch (error) {
        console.error('خطأ في الإرسال:', error);
        alert('حدث خطأ أثناء الإرسال: ' + error.message);
        this.generateCaptcha();
      } finally {
        this.isSubmitting = false;
      }
    },

    getCsrfToken() {
      const metaTag = document.querySelector('meta[name="csrf-token"]');
      if (metaTag) {
        return metaTag.getAttribute('content');
      }

      if (window.Laravel && window.Laravel.csrfToken) {
        return window.Laravel.csrfToken;
      }

      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      if (cookieValue) {
        return decodeURIComponent(cookieValue);
      }

      console.warn('لم يتم العثور على رمز CSRF');
      return '';
    },

    validateForm() {
      const requiredFields = {
        'nom_prenom': 'الاسم الكامل',
        'statut': 'الصفة',
        'wilaya': 'الولاية',
        'telephone': 'الهاتف',
        'canal_achat': 'قناة الشراء',
        'rempli_par_representant': 'تم تقديم الشكوى من طرف ممثل بروفارت',
        'gamme_produit': 'مجموعة المنتج',
        'produit_id': 'المنتج',
        'motif': 'سبب الشكوى',
        'date_livraison': 'تاريخ التسليم'
      };

      for (const [field, label] of Object.entries(requiredFields)) {
        if (!this.form[field]) {
          alert(`الحقل "${label}" إلزامي`);
          return false;
        }
      }

      // Validation du nom du représentant si oui
      if (this.form.rempli_par_representant === 'oui' && !this.form.representant_profert) {
        alert('اسم ممثل بروفارت إلزامي');
        return false;
      }

      if (this.isNumeroLotRequired && !this.form.numero_lot) {
        alert('رقم الدفعة إلزامي لهذا السبب من الشكوى');
        return false;
      }

      if (this.form.date_livraison && !this.validateDateLivraison()) {
        alert('الرجاء تصحيح تاريخ التسليم');
        return false;
      }

      if (this.form.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.form.email)) {
          alert('يرجى إدخال عنوان بريد إلكتروني صحيح');
          return false;
        }
      }

      const phoneDigits = this.form.telephone.replace(/\D/g, '');
      if (phoneDigits.length !== 9) {
        alert('رقم الهاتف يجب أن يحتوي على 9 أرقام (بدون +213)');
        return false;
      }

      return true;
    },

    resetForm() {
      this.form = {
        nom_prenom: '',
        email: '',
        statut: '',
        wilaya: '',
        telephone: '',
        codeclient: '',
        canal_achat: '',
        rempli_par_representant: '',
        representant_profert: '',
        gamme_produit: '',
        produit_id: '',
        numero_lot: '',
        date_livraison: '',
        quantite_non_conforme: '',
        motif: '',
        description: ''
      };
      this.produits = [];
      this.selectedFiles = [];
      this.generateCaptcha();
      this.allProduits = [];
      this.filteredProduits = [];
      this.produitSearch = '';
      this.showProduitDropdown = false;
      this.dateError = '';
      this.setMaxDate();
    },

    closeSuccessModal() {
      this.showSuccess = false;
      this.resetForm();
    },
    
    formatPhoneNumber() {
      let numbers = this.form.telephone.replace(/\D/g, '');
      numbers = numbers.substring(0, 9);
      this.form.telephone = numbers;
    },
  }
}
</script>

<style scoped>
.font-mono {
  font-family: 'Courier New', monospace;
}

.tracking-wider {
  letter-spacing: 0.1em;
}

.select-none {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* Styles pour le dropdown personnalisé */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
}

.z-50 {
  z-index: 50;
}

.max-h-60 {
  max-height: 15rem;
}

input:disabled {
  background-color: #f9fafb;
  cursor: not-allowed;
}

.dropdown-enter-active {
  animation: dropdownFadeIn 0.2s ease-out;
}

.dropdown-leave-active {
  animation: dropdownFadeOut 0.2s ease-in;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes dropdownFadeOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

.max-h-60::-webkit-scrollbar {
  width: 6px;
}

.max-h-60::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.max-h-60::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* تخصيصات للغة العربية */
[dir="rtl"] {
  text-align: right;
}

[dir="rtl"] .text-right {
  text-align: right;
}

[dir="rtl"] .ml-1 {
  margin-left: 0;
  margin-right: 0.25rem;
}

[dir="rtl"] .ml-2 {
  margin-left: 0;
  margin-right: 0.5rem;
}

[dir="rtl"] .mr-1 {
  margin-right: 0;
  margin-left: 0.25rem;
}

[dir="rtl"] .mr-2 {
  margin-right: 0;
  margin-left: 0.5rem;
}

[dir="rtl"] .mr-4 {
  margin-right: 0;
  margin-left: 1rem;
}

[dir="rtl"] .space-x-reverse > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

[dir="rtl"] .pr-16 {
  padding-right: 4rem;
  padding-left: 0.75rem;
}

[dir="rtl"] .absolute.left-3 {
  left: auto;
  right: 0.75rem;
}
</style>